import _defineProperty from '../../../node_modules/@babel/runtime/helpers/esm/defineProperty.js';
import React__default from 'react';
import { makeStyles, Container, Typography, Grid } from '@material-ui/core';
import clsx from 'clsx';
import { useBreakpoints } from '../../hooks/useBreakpoints.js';
import PropTypes__default from 'prop-types';
import { retrieveContentfulImage } from '../../common/image.js';

var useStyles = makeStyles(function (theme) {
  return {
    tiles3Container: {
      width: "100%",
      padding: theme.spacing(7.5, 0),
      zIndex: -2
    },
    wrapper: {
      margin: "0 auto",
      position: "relative"
    },
    titleBackground: {
      width: "100%",
      height: "50%",
      position: "absolute",
      bottom: 0,
      left: 0
    },
    widthFitContent: {
      width: "fit-content"
    },
    mb7: {
      marginBottom: theme.spacing(7)
    },
    mb8: {
      marginBottom: theme.spacing(8)
    },
    colorWhite: {
      color: theme.palette.text.white
    },
    maxWidth310: {
      maxWidth: theme.spacing(38.75)
    },
    maxWidth342: {
      maxWidth: theme.spacing(42.75)
    },
    title: {
      background: "linear-gradient(bottom, rgba(112, 194, 118, 0.3) 60%, transparent 40%)"
    }
  };
});
var Tiles3 = function Tiles3(_ref) {
  var title = _ref.title,
    text = _ref.text,
    imageUrl = _ref.imageUrl;
  var classes = useStyles();
  var _useBreakpoints = useBreakpoints(),
    isExtraSmallScreen = _useBreakpoints.isExtraSmallScreen;
  var bgImageOptions = {
    sizeOptions: {
      fit: "fill"
    }
  };
  var backgroundFilter = "linear-gradient(0deg, rgba(39, 24, 1, 0.7), rgba(39, 24, 1, 0.7))";
  var styles = {
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat"
  };
  if (imageUrl) {
    styles["backgroundImage"] = "".concat(backgroundFilter, ",url(").concat(retrieveContentfulImage(imageUrl, bgImageOptions.sizeOptions), ")");
  }
  return /*#__PURE__*/React__default.createElement("div", {
    style: styles,
    className: classes.tiles3Container
  }, /*#__PURE__*/React__default.createElement(Container, {
    maxWidth: "lg"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: clsx(classes.wrapper, _defineProperty({}, classes.widthFitContent, !isExtraSmallScreen()), _defineProperty({}, classes.maxWidth310, isExtraSmallScreen()))
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.titleBackground
  }), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h3",
    align: "center",
    component: "h2",
    className: clsx(classes.mb8, classes.colorWhite, classes.title, _defineProperty({}, classes.widthFitContent, !isExtraSmallScreen()), _defineProperty({}, classes.maxWidth310, isExtraSmallScreen()))
  }, title)), /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    justify: isExtraSmallScreen() ? "center" : "space-between",
    className: clsx(_defineProperty({}, classes.wrapper, isExtraSmallScreen()), _defineProperty({}, classes.maxWidth310, isExtraSmallScreen()))
  }, text === null || text === void 0 ? void 0 : text.map(function (item) {
    return /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4,
      className: clsx(_defineProperty({}, classes.maxWidth342, !isExtraSmallScreen()), classes.mb7),
      key: item
    }, /*#__PURE__*/React__default.createElement(Typography, {
      variant: "h6",
      component: "div",
      align: "center",
      className: classes.colorWhite
    }, item));
  }))));
};
Tiles3.defaultProps = {};
Tiles3.propTypes = {
  title: PropTypes__default.string,
  imageUrl: PropTypes__default.string,
  text: PropTypes__default.array
};

export { Tiles3 as default };
//# sourceMappingURL=Tiles3.js.map
